import React from "react";
import pt from "prop-types";
import BaseComponent from "meta/features/base-component";
import Cookie from "js-cookie";

const OVERLAY_START_TIME = 30;

class InactivityOverlay extends BaseComponent {
  constructor() {
    super();
    this.state = {
      remainingTime: "none",
    };
  }

  componentDidMount() {
    setInterval(() => {
      let validTill =
        parseInt(Cookie.get("LastActivity")) +
        parseInt(Cookie.get("LastActivityInt"));
      this.setState({
        remainingTime: Math.round((validTill - Date.now()) / 1000),
      });
    }, 1000);
  }

  render() {
    let { userLoggedIn, inactivityLogoutActive } = this.props;
    let { remainingTime } = this.state;

    if (
      userLoggedIn && (inactivityLogoutActive || (
      Number.isInteger(remainingTime) &&
      remainingTime <= OVERLAY_START_TIME))
    ) {
      return (
        <div className="inactivity-overlay">
          <div className="inactivity-overlay-panel">
            <span className="title">Inactivity logout</span>
            <p>
              You seem to be inactive and will be logged out
              {remainingTime > 0 && !inactivityLogoutActive  ? ` in ${remainingTime} seconds` : ""}.<br />
              Click anywhere on screen to prevent the logout.
            </p>
          </div>
        </div>
      );
    }

    return null;
  }
}

InactivityOverlay.propTypes = {
  userLoggedIn: pt.bool,
};
InactivityOverlay.defaultProps = {
  userLoggedIn: false,
};

export default InactivityOverlay;
